import { css } from 'styled-components'
import { theme } from 'twin.macro'

export const adStyles = css`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  text-align: center;
  overflow: hidden;
  border-radius: 4px;

  &:empty {
    display: none;
  }
`

export const recommendedArticleAdStyles = css`
  display: none;
  width: 100%;
  height: 90px;
  margin: 0 auto 40px auto;
  @media (min-width: ${theme`screens.md`}) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
